import { debounce } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $documentElement = document.documentElement;
    const scrollThreshold = 10;
    let lastScrollTop = 0;

    const handleScroll = () => {
        const currentScrollTop = window.scrollY;
        const scrollDiff = currentScrollTop - lastScrollTop;
        const scrollingUp = scrollDiff < -scrollThreshold;
        const scrollingDown = scrollDiff > scrollThreshold;
        const atBottom = window.innerHeight + currentScrollTop >= document.documentElement.scrollHeight - 1;

        if (currentScrollTop === 0) {
            $documentElement.classList.remove('is-scrolled');
        } else {
            $documentElement.classList.add('is-scrolled');
        }

        lastScrollTop = currentScrollTop;
    };


    const debouncedHandleScroll = debounce(handleScroll, 50);

    document.addEventListener('scroll', debouncedHandleScroll);

    window.addEventListener('resize', debouncedHandleScroll);

    handleScroll();
});
